export default function () {
  const widgetName = 'featureCards';
  const widgetOpts = featureCardsOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    cardWidgetLoaded: function (slide) {

      function customWidget() {

   

        let number = 1;
        $(`#${widgetName} .card-widget-item`).each(function (x) {
          $(this).find('.image-container').append('<div class="overlay"></div>');
          $(this).find('.image-container').append(`<a href="${slide.items[x].URL}"class="card-btn button">Learn More</a>`)
          $(this).find('.buttonwrap').remove();
          $(this).find('.card-content')

          $(this).find('.card-content').each(function () {
            $(this).prepend(`<img src="" class="icon icon-${number}"></img>`);
            number++;
          });
        })
      }

      customWidget()

      setTimeout(() => {
        $(`#${widgetName}`).each(function () {
          $(this).attr({
            "data-aos": 'fade-in',
            "data-aos-easing": "ease-in-out",
            "data-aos-duration": "600",
            "data-aos-delay": "300",
            "data-aos-once": "true",
            "data-aos-offset":"300"
          });
        })
      }, 800);

    },
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    link: [''], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 4,
    moreButton: {
      visible: true,
      text: 'Learn More'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: false
  });
}